export default "__VITE_ASSET__DbUIFsT$__"